import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLazyQuery } from '@apollo/client';

import './ConfirmAccount.scss';
import Button from '../../component/button/Button';
import { confirmAccount } from '../../service/utils/functions';
import { USER_MANAGEMENT_CHECK } from '../../service/graphql/auth';

const ConfirmAccount = () => {
  const navigate = useNavigate();
  const [urlParams] = useSearchParams();
  const [confirmCode, setConfirmCode] = useState('');
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');

  const [checkUserValidity] = useLazyQuery(USER_MANAGEMENT_CHECK);

  useEffect(() => {
    const confirmation = urlParams.get('confirmation');
    if (confirmation) {
      window.history.replaceState(null, '', `/account-confirmation?${urlParams.toString()}`);
      setConfirmCode(confirmation);
    } else {
      setErrorMsg('An error occurred: Invalid or expired confirmation code');
      setLoading(false);
    }
  }, [urlParams]);

  useEffect(() => {
    if (confirmCode && confirmCode.length > 0) {
      confirmAccount(confirmCode).then(async res => {
        if (res && res.user) {
          const u = res.user;
          const isConfirmed = await checkUserValidity({
            variables: {
              email: u.email,
              username: u.username,
              action: 'confirm'
            },
            context: {
              apiName: 'middleware'
            }
          });
          if (isConfirmed) setLoading(false);
          else {
            setErrorMsg('An error occurred: Unable to confirm user');
            setLoading(false);
          }
        } else {
          setErrorMsg('An error occurred: Invalid or expired confirmation code');
          setLoading(false);
        }
      });
    }
  }, [confirmCode, navigate, checkUserValidity])

  return (
    <div className='screen-bg-confirm'>
      <h1>{loading ? 'Confirming account...' : errorMsg && errorMsg.length > 0 ?
        errorMsg :
        'Your account has been created. You can access BRAD portal using your email and password'
      }</h1>
      {!loading && (
        <Button
          title='Return to Login'
          onClick={() => {
            window.history.replaceState(null, '', '/');
            navigate('/login');
          }}
        />
      )}
    </div>
  );
};

export default ConfirmAccount